import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, IconButton, Popover, Stack, Typography } from '@mui/material';

const DEFAULT_CONFIRM_POPOVER_TITLE = 'Confirm action';

interface ConfirmPopoverProps {
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmPopover = ({
  anchorEl,
  isOpen,
  title = DEFAULT_CONFIRM_POPOVER_TITLE,
  message,
  onConfirm,
  onCancel,
}: ConfirmPopoverProps) => {
  const isPopoverOpen = isOpen && Boolean(anchorEl);

  return (
    <Popover
      open={isPopoverOpen}
      anchorEl={anchorEl}
      onClose={onCancel}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          role: 'dialog',
          'aria-label': title,
        },
      }}
    >
      <Box sx={{ p: 1.5, maxWidth: 300 }}>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <WarningAmberRoundedIcon fontSize="small" color="warning" />

            <Typography variant="subtitle2">{title}</Typography>
          </Stack>

          <Stack direction="row" spacing={0.25} alignItems="center">
            <IconButton aria-label="Confirm" size="small" onClick={onConfirm} color="success">
              <CheckRoundedIcon fontSize="small" />
            </IconButton>

            <IconButton aria-label="Cancel" size="small" onClick={onCancel} color="error">
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>

        <Typography variant="body2" color="textSecondary">
          {message}
        </Typography>
      </Box>
    </Popover>
  );
};

export default ConfirmPopover;
